import { render, staticRenderFns } from "./ui-carousel.vue?vue&type=template&id=14c54bd0&"
import script from "./ui-carousel.vue?vue&type=script&lang=js&"
export * from "./ui-carousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14c54bd0')) {
      api.createRecord('14c54bd0', component.options)
    } else {
      api.reload('14c54bd0', component.options)
    }
    module.hot.accept("./ui-carousel.vue?vue&type=template&id=14c54bd0&", function () {
      api.rerender('14c54bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/carousel/ui-carousel.vue"
export default component.exports